import React from 'react';
import { ListRenderItem } from 'react-native';
import styled from 'styled-components/native';

import JourneyCard from '@src/components/JourneyCard';
import RefreshControl from '@src/components/RefreshControl';
import Separator from '@src/components/Separator';
import { padding } from '@src/configuration/constants';
import { Journey } from '@src/types';

import EmptyJourney from './EmptyJourney';
import { JourneyList } from './styled';
import useFriendsJourneys from './useFriendsJourneys';
import useUserJourneys from './useUserJourneys';

type Props = {};

const Container = styled.View`
  margin: ${padding * 2}px auto;
  width: 100%;
`;

export const FriendsJourneys: React.FC<Props> = () => {
  const friendsJourneys = useFriendsJourneys();
  const userJourneys = useUserJourneys();

  const data: Journey[] = React.useMemo(
    () => [
      ...(userJourneys?.data ? userJourneys.data : []),
      ...(friendsJourneys?.data ? friendsJourneys.data : []),
    ],
    [friendsJourneys, userJourneys]
  );

  const refreshing: boolean = React.useMemo(
    () => friendsJourneys.refreshing || userJourneys.loading,
    [friendsJourneys.refreshing, userJourneys.loading]
  );

  const handleRefresh = () => friendsJourneys.handleRefresh;

  const handleEndReached = () => friendsJourneys.handleEndReached;

  const renderItem: ListRenderItem<Journey> = React.useCallback(
    ({ item }) => <JourneyCard item={item} />,
    []
  );

  return (
    <Container>
      <JourneyList
        data={data}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
        }
        initialNumToRender={data.length}
        onEndReached={handleEndReached}
        renderItem={renderItem}
        ItemSeparatorComponent={Separator}
        ListEmptyComponent={<EmptyJourney />}
      />
    </Container>
  );
};
